import { compact } from 'lodash'
/**
 * Validate uniqueness of tip option values, allowing null values.
 *
 */

export const validateTipOptions = (
  tipValues,
  provide_tip_suggestions
) => {
  if (!provide_tip_suggestions) return true

  const tipOptionsWithoutNull = compact(tipValues)

  if (!tipOptionsWithoutNull.length) return true

  return (
    new Set(tipOptionsWithoutNull).size ===
    tipOptionsWithoutNull.length
  )
}
